import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";

enableHMRForChain(chain);

type loadOrdersProps = Parameters<typeof LoadProducts>[0];

export const LoadAllProducts = (props: loadOrdersProps) => {
    const {
        parameter: { carouselType, numberOfProductsToDisplay },
    } = props;

    if (carouselType !== "allProducts") {
        return;
    }

    props.getProductCollectionParameter = { pageSize: numberOfProductsToDisplay };
};
addToChainBefore(chain, LoadProducts, LoadAllProducts);
